import { render, staticRenderFns } from "./DemographicsStUpper.vue?vue&type=template&id=c4f141b0&"
import script from "./DemographicsStUpper.vue?vue&type=script&lang=js&"
export * from "./DemographicsStUpper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports